import configuration from '@/configuration'
import { admin2 } from './instance'

/* MemberShopProduct 商品 */
export const GetMemberShopProduct = async ({
  shopId, start,
  limit,
  type,
  name,
  isPointExchange,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreProduct`,
    params: {
      start,
      limit,
      type,
      name,
      isPointExchange,
    },
  })
}
export const GetMemberShopProductCount = async ({
  shopId,
  type,
  name,
  isPointExchange,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreProduct/count`,
    params: {
      type,
      name,
      isPointExchange,
    },
  })
}
export const FindMemberShopProduct = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreProduct/${id}`,
  })
}

/**
 * 建立會員商城商品 admin.memberStoreProduct.create
 * @param {Object} params - 建立參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.type - 商品類型
 * @param {number} [params.walletAmount] - 儲值金金額
 * @param {number} [params.externalWalletAmount] - 第三方會員餘額金額
 * @param {string} [params.classTicketId] - 堂票ID
 * @param {string} [params.pointCardId] - 點數卡ID
 * @param {string} [params.punchCardId] - 次卡ID
 * @param {string} [params.periodicBenefitTemplateId] - 會員權益範本ID
 * @param {string} [params.externalProductSourceType] - 第三方商品來源類型
 * @param {Object} [params.externalProductConfig] - 第三方商品設定
 * @param {Object} [params.externalProductConfig.cyjPos] - CYJ POS 商品設定
 * @param {string} [params.externalProductConfig.cyjPos.itemCode] - CYJ POS 商品分類碼
 * @param {string|null} [params.externalProductConfig.cyjPos.name] - CYJ POS 商品名稱
 * @param {string} params.name - 商品名稱
 * @param {string} params.description - 商品描述
 * @param {string} params.notice - 注意事項
 * @param {string|null} [params.imageId] - 圖片ID
 * @param {boolean} params.isPublic - 是否公開
 * @param {boolean} [params.isPaymentPromise] - 是否為價保商品
 * @param {number} params.price - 售價
 * @param {number} [params.useCashbackRate] - 回饋金可折抵比例
 * @param {number} params.order - 排序
 * @param {string} [params.promisePaymentConfigId] - 價保支付設定ID
 * @returns {import('@/api/instance').Api2Response<Object>} 建立結果
 */
export const CreateMemberShopProduct = async ({
  shopId,
  type,
  walletAmount,
  externalWalletAmount,
  classTicketId,
  pointCardId,
  punchCardId,
  periodicBenefitTemplateId,
  name,
  description,
  notice,
  imageId,
  isPublic,
  isPaymentPromise,
  price,
  useCashbackRate,
  order,
  promisePaymentConfigId,
  externalProductSourceType,
  externalProductConfig,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreProduct`,
    data: {
      type,
      walletAmount,
      externalWalletAmount,
      classTicketId,
      pointCardId,
      punchCardId,
      periodicBenefitTemplateId,
      name,
      description,
      notice,
      imageId,
      isPublic,
      isPaymentPromise,
      price,
      useCashbackRate,
      order,
      promisePaymentConfigId,
      externalProductSourceType,
      externalProductConfig,
    },
  })
}

/**
 * 更新會員商城商品 admin.memberStoreProduct.update
 * @param {Object} params - 更新參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.id - 商品ID
 * @param {string} params.name - 商品名稱
 * @param {string} params.description - 商品描述
 * @param {string} params.notice - 注意事項
 * @param {string|null} [params.imageId] - 圖片ID
 * @param {boolean} params.isPublic - 是否公開
 * @param {boolean} [params.isPaymentPromise] - 是否為價保商品
 * @param {number} params.price - 售價
 * @param {number} [params.useCashbackRate] - 回饋金可折抵比例
 * @param {number} params.order - 排序
 * @param {number} [params.walletAmount] - 儲值金金額
 * @param {number} [params.externalWalletAmount] - 第三方會員餘額金額
 * @param {string} [params.externalProductSourceType] - 第三方商品來源類型
 * @param {Object} [params.externalProductConfig] - 第三方商品設定
 * @returns {import('@/api/instance').Api2Response<Object>} 更新結果
 */
export const UpdateMemberShopProduct = async ({
  shopId,
  id,
  name,
  description,
  notice,
  imageId,
  isPublic,
  isPaymentPromise,
  price,
  useCashbackRate,
  order,
  walletAmount,
  externalWalletAmount,
  externalProductSourceType,
  externalProductConfig,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/memberStoreProduct/${id}`,
    data: {
      name,
      description,
      notice,
      imageId,
      isPublic,
      isPaymentPromise,
      price,
      useCashbackRate,
      order,
      walletAmount,
      externalWalletAmount,
      externalProductSourceType,
      externalProductConfig,
    },
  })
}

export const DeleteMemberShopProduct = async ({
  shopId,
  id,
}) => {
  return await admin2({
    method: 'DELETE',
    url: `/${shopId}/memberStoreProduct/${id}`,
  })
}

/* MemberShopOrder 訂單 */
export const GetMemberShopOrder = async ({
  shopId,
  start,
  limit,
  MemberId,
  code,
  status,
  paymentStatus,
  isCyjPosDepositCreated,
  isPointExchange,
  createdAtStart,
  createdAtEnd,
  includeCustomFlowRecord,
  includeSignatureMapping,
  customFlowNodeId,
  shopPointKey,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreOrder`,
    params: {
      start,
      limit,
      MemberId,
      code,
      status,
      paymentStatus,
      isCyjPosDepositCreated,
      isPointExchange,
      createdAtStart,
      createdAtEnd,
      includeCustomFlowRecord,
      includeSignatureMapping,
      customFlowNodeId,
      shopPointKey,
    },
  })
}
export const GetMemberShopOrderCount = async ({
  shopId,
  MemberId,
  code,
  status,
  paymentStatus,
  isCyjPosDepositCreated,
  isPointExchange,
  createdAtStart,
  createdAtEnd,
  customFlowNodeId,
  shopPointKey,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreOrder/count`,
    params: {
      MemberId,
      code,
      status,
      paymentStatus,
      isCyjPosDepositCreated,
      isPointExchange,
      createdAtStart,
      createdAtEnd,
      customFlowNodeId,
      shopPointKey,
    },
  })
}
export const FindMemberShopOrder = async ({
  shopId,
  id,
  includeCustomFlowRecord,
  includeSignatureMapping,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreOrder/${id}`,
    params: {
      includeCustomFlowRecord,
      includeSignatureMapping,
    },
  })
}
export const FindMemberShopOrderTransitionCodes = async ({
  shopId,
  id,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreOrder/${id}/transitionCodes`,
  })
}

/**
 * 更新商城訂單配送狀態
 * @param {Object} params - 更新參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.id - 訂單ID
 * @param {string} params.status - 配送狀態
 * @returns {Promise<Object>} 更新後的商城訂單資料
 */
export const UpdateMemberShopOrderDeliveryStatus = async ({
  shopId,
  id,
  status,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/memberStoreOrder/${id}/deliveryStatus`,
    data: {
      status,
    },
  })
}

export const FindMemberShopOrderLogs = async ({
  shopId,
  id,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreOrder/${id}/logs`,
  })
}
export const FindMemberShopOrderProductDetail = async ({
  shopId,
  id,
  memberStoreOrderProductId,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreOrder/${id}/orderProduct/${memberStoreOrderProductId}/view`,
  })
}

export const CancelMemberShopOrder = async ({
  shopId,
  id,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/memberStoreOrder/${id}/cancel`,
  })
}
/**
 * 訂單退款
 * @featureKey admin.memberStoreOrder.refundPayment
 * @param {Object} param0
 * @param {string} param0.shopId
 * @param {string} param0.id
 * @param {Object} param0.refundPayment
 * @returns {Promise<Object>}
 */
export const MemberShopOrderRefund = async ({
  shopId,
  id,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreOrder/${id}/refundPayment`,
  })
}

/**
 * 訂單退款 (透過 PaymentTrustOrder)
 * @featureKey admin.memberStoreOrder.refundPaymentByPaymentTrustOrder
 * @param {Object} param0
 * @param {string} param0.shopId
 * @param {string} param0.id
 * @param {boolean} param0.useMemberStoreRefundAdminFee 是否要啟用退款行政處理費
 * @param {string} param0.memberStoreRefundAdminFeeInvoiceTitle 退款行政處理費名稱
 * @param {number} param0.memberStoreRefundAdminFeeAmount 退款行政處理費金額
 * @param {boolean} param0.useMemberStoreRefundAdminFeeInvoice 退款行政處理費是否要開立發票
 * @returns {Promise<Object>}
 */
export const MemberShopOrderRefundByPaymentTrustOrder = async ({
  shopId,
  id,
  useMemberStoreRefundAdminFee,
  memberStoreRefundAdminFeeAmount,
  useMemberStoreRefundAdminFeeInvoice,
  memberStoreRefundAdminFeeInvoiceTitle,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreOrder/${id}/refundPaymentByPaymentTrustOrder`,
    data: {
      useMemberStoreRefundAdminFee,
      memberStoreRefundAdminFeeAmount,
      useMemberStoreRefundAdminFeeInvoice,
      memberStoreRefundAdminFeeInvoiceTitle,
    },
  })
}

export const MemberShopOrderInvalidInvoice = async ({ shopId, id }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreOrder/${id}/invalidInvoice`,
  })
}
export const MemberShopOrderIssueInvoice = async ({ shopId, id }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreOrder/${id}/issueInvoice`,
  })
}
export const MemberShopOrderAllowanceAllInvoice = async ({ shopId, id }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreOrder/${id}/allowanceAllInvoice`,
  })
}
export const MemberShopOrderRecycleProduct = async ({ shopId, orderId, id }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreOrder/${orderId}/product/${id}/recycle`,
  })
}
export const MemberShopOrderSendProduct = async ({ shopId, orderId, id }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreOrder/${orderId}/product/${id}/send`,
  })
}
export const MemberShopOrderCanelPayment = async ({ shopId, id }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreOrder/${id}/cancelPayment`,
  })
}

/* MemberShopGiveaway 優惠活動 */
export const GetMemberShopGiveaway = async ({
  shopId,
  start,
  limit,
  name,
  status,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStorePromotion`,
    params: {
      start,
      limit,
      name,
      status,
    },
  })
}
export const GetMemberShopGiveawayCount = async ({
  shopId,
  name,
  status,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStorePromotion/count`,
    params: {
      name,
      status,
    },
  })
}
export const FindMemberShopGiveaway = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStorePromotion/${id}`,
  })
}
export const CreateMemberShopGiveaway = async ({
  shopId,
  name,
  startAt,
  endAt,
  targetProductIds,
  conditions,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/memberStorePromotion`,
    data: {
      name,
      startAt,
      endAt,
      targetProductIds,
      conditions,
    },
  })
}
export const UpdateMemberShopGiveaway = async ({
  shopId,
  id,
  name,
  startAt,
  endAt,
  targetProductIds,
  conditions,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/memberStorePromotion/${id}`,
    data: {
      name,
      startAt,
      endAt,
      targetProductIds,
      conditions,
    },
  })
}
export const DeleteMemberShopGiveaway = async ({
  shopId,
  id,
}) => {
  return await admin2({
    method: 'DELETE',
    url: `/${shopId}/memberStorePromotion/${id}`,
  })
}

/* MemberShopPayments 付款方式 */
export const GetMemberShopPaymentConfig = async ({
  shopId,
  start,
  limit,
  isOnline,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStorePaymentConfig`,
    params: {
      start,
      limit,
      isOnline,
    },
  })
}
export const GetMemberShopPaymentConfigCount = async ({
  shopId,
  isOnline,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStorePaymentConfig/count`,
    params: {
      isOnline,
    },
  })
}
export const FindMemberShopPaymentConfig = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStorePaymentConfig/${id}`,
  })
}
export const CreateMemberShopPaymentConfig = async ({
  shopId,
  name,
  enable,
  limitProductType,
  type,
  paymentConfig,
  isPaymentPromise,
  paymentPromiseVendor,
  promisePeriodDays,
  promiseConfig,
  autoRefundEnabled,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/memberStorePaymentConfig`,
    data: {
      name,
      enable,
      limitProductType,
      type,
      paymentConfig,
      isPaymentPromise,
      paymentPromiseVendor,
      promisePeriodDays,
      promiseConfig,
      autoRefundEnabled,
    },
  })
}
export const UpdateMemberShopPaymentConfig = async ({
  shopId,
  id,
  name,
  enable,
  autoRefundEnabled,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/memberStorePaymentConfig/${id}`,
    data: {
      name,
      enable,
      autoRefundEnabled,
    },
  })
}
export const DeleteMemberShopPaymentConfig = async ({
  shopId,
  id,
}) => {
  return await admin2({
    method: 'DELETE',
    url: `/${shopId}/memberStorePaymentConfig/${id}`,
  })
}

/* MemberShopInvoice 發票 */
export const GetMemberShopInvoiceConfig = async ({ shopId }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreInvoiceConfig`,
  })
}
export const UpdateMemberShopInvoiceConfig = async ({
  shopId,
  enable,
  platform,
  invoiceApiConfig,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/memberStoreInvoiceConfig`,
    data: {
      enable,
      platform,
      invoiceApiConfig,
    },
  })
}

/* 點數兌換 */
export const CheckCreatePointExchangeProduct = async ({ shopId }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreProduct/createCheck`,
    params: { type: 'general' },
  })
}

export const GetMemberStoreDeliveries = async ({ shopId }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreDelivery`,
  })
}

/**
 * 新增點數兌換商品 admin.memberStoreProduct.createByPointExchange
 * @param {object} params
 * @param {string} params.shopId - 店家 ID
 * @param {string} params.type - 商品類型
 * @param {string} [params.classTicket] - 課程票 ID（type=classTicket 時必填）
 * @param {string} [params.couponId] - 優惠券 ID（type=coupon 時必填）
 * @param {string} [params.punchCardId] - 次卡 ID（type=punchCard 時必填）
 * @param {string} [params.pointCardId] - 點數卡 ID（type=pointCard 時必填）
 * @param {number} [params.cashbackAmount] - 回饋金額（type=cashback 時必填）
 * @param {number} [params.walletAmount] - 儲值金額（type=wallet 時必填）
 * @param {string} params.name - 商品名稱
 * @param {string} [params.description] - 商品說明
 * @param {string} [params.notice] - 注意事項
 * @param {string} [params.imageId] - 圖片 ID
 * @param {boolean} params.isPublic - 是否公開
 * @param {boolean} params.isPaymentPromise - 是否啟用分期付款
 * @param {number} params.price - 售價
 * @param {number} params.pointExchangeAmount - 點數兌換數量
 * @param {number} [params.externalPointAmount] - 外部點數數量
 * @param {number} [params.order] - 排序
 * @param {string} [params.promisePaymentConfigId] - 分期付款設定 ID（isPaymentPromise=true 時必填）
 * @param {string} [params.shopPointKey] - 店家點數 key
 * @param {string} params.deliveryMode - 運送方式（unlimited | limit）
 * @param {string[]} [params.limitMemberStoreDeliveryIds] - 指定運送方式 ID 列表（deliveryMode=limit 時必填）
 * @param {boolean} [params.isCustomerPayShipping] - 顧客是否需要自付運費
 * @param {string|null} [params.giftCouponId] - 一般商品附贈票券 ID
 * @returns {import('@/api/instance').Api2Response}
 */
export const CreatePointExchangeProduct = async ({
  shopId,
  type,
  classTicket: classTicketId,
  couponId,
  punchCardId,
  pointCardId,
  cashbackAmount,
  walletAmount,
  name,
  description,
  notice,
  imageId,
  isPublic,
  isPaymentPromise,
  price,
  pointExchangeAmount,
  externalPointAmount,
  order,
  promisePaymentConfigId,
  shopPointKey,
  deliveryMode,
  limitMemberStoreDeliveryIds,
  isCustomerPayShipping,
  giftCouponId,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreProduct/createByPointExchange`,
    data: {
      type,
      classTicketId,
      punchCardId,
      pointCardId,
      cashbackAmount,
      walletAmount,
      name,
      description,
      notice,
      imageId,
      isPublic,
      isPaymentPromise,
      price,
      pointExchangeAmount,
      externalPointAmount,
      order,
      couponId,
      promisePaymentConfigId,
      shopPointKey,
      deliveryMode,
      limitMemberStoreDeliveryIds,
      isCustomerPayShipping,
      giftCouponId,
    },
  })
}

/**
 * 更新點數兌換商品 admin.memberStoreProduct.updateByPointExchange
 * @param {object} params
 * @param {string} params.shopId - 店家 ID
 * @param {string} params.id - 商品 ID
 * @param {string} params.name - 商品名稱
 * @param {string} [params.description] - 商品說明
 * @param {string} [params.notice] - 注意事項
 * @param {string} [params.imageId] - 圖片 ID
 * @param {boolean} params.isPublic - 是否公開
 * @param {boolean} params.isPaymentPromise - 是否啟用分期付款
 * @param {number} params.price - 售價
 * @param {number} params.pointExchangeAmount - 點數兌換數量
 * @param {number} [params.externalPointAmount] - 外部點數數量
 * @param {number} [params.cashbackAmount] - 回饋金額
 * @param {number} [params.walletAmount] - 儲值金額
 * @param {number} [params.order] - 排序
 * @param {string} [params.promisePaymentConfigId] - 分期付款設定 ID（isPaymentPromise=true 時必填）
 * @param {string} [params.shopPointKey] - 店家點數 key
 * @param {string} params.deliveryMode - 運送方式（unlimited | limit）
 * @param {string[]} [params.limitMemberStoreDeliveryIds] - 指定運送方式 ID 列表（deliveryMode=limit 時必填）
 * @param {boolean} [params.isCustomerPayShipping] - 顧客是否需要自付運費
 * @param {string|null} [params.giftCouponId] - 一般商品附贈票券 ID（null 表示移除）
 * @returns {import('@/api/instance').Api2Response}
 */
export const UpdateMemberShopProductByPointExchange = async ({
  shopId,
  id,
  name,
  description,
  notice,
  imageId,
  isPublic,
  isPaymentPromise,
  price,
  pointExchangeAmount,
  externalPointAmount,
  cashbackAmount,
  walletAmount,
  order,
  promisePaymentConfigId,
  shopPointKey,
  deliveryMode,
  limitMemberStoreDeliveryIds,
  isCustomerPayShipping,
  giftCouponId,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/memberStoreProduct/${id}/updateByPointExchange`,
    data: {
      name,
      description,
      notice,
      imageId,
      isPublic,
      isPaymentPromise,
      price,
      pointExchangeAmount,
      externalPointAmount,
      cashbackAmount,
      walletAmount,
      order,
      promisePaymentConfigId,
      shopPointKey,
      deliveryMode,
      limitMemberStoreDeliveryIds,
      isCustomerPayShipping,
      giftCouponId,
    },
  })
}

export const GetRewardActivity = async ({
  shopId,
  start,
  limit,
  source,
  rewardType,
  name,
  enabled,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/rewardActivity`,
    params: {
      start,
      limit,
      source,
      rewardType,
      name,
      enabled,
    },
  })
}

export const GetRewardActivityCount = async ({
  shopId,
  source,
  rewardType,
  name,
  enabled,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/rewardActivity/count`,
    params: {
      source,
      rewardType,
      name,
      enabled,
    },
  })
}

export const DeleteMemberShopRewardActivity = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'DELETE',
    url: `/${shopId}/rewardActivity/${id}`,
  })
}

// 會員商城公開頁設定
export const GetMemberShopPublicPageConfig = async ({
  shopId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStorePublicPageConfig`,
  })
}

// 更新會員商城公開頁設定
export const UpdateMemberShopPublicPageConfig = async ({
  shopId,
  name,
  address,
  phone,
  shopIdentifier,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/memberStorePublicPageConfig`,
    data: {
      name,
      address,
      phone,
      shopIdentifier,
    },
  })
}

export const GetPaymentTrustOrderPreRefundDetail = async ({
  shopId,
  id,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/paymentTrustOrder/${id}/preRefundDetail`,
  })
}

export const RefundPaymentTrustOrder = async ({
  shopId,
  id,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/paymentTrustOrder/${id}/refund`,
  })
}

export const GetMemberStorePointConfig = async ({ shopId }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStorePointConfig`,
  })
}

export const UpdateMemberStorePointConfig = async ({
  shopId,
  pointExchangeDisplayName,
  pointExchangeRecordDisplayName,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/memberStorePointConfig`,
    data: {
      pointExchangeDisplayName,
      pointExchangeRecordDisplayName,
    },
  })
}

export const GetMemberStoreConfig = async ({ shopId }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreConfig`,
  })
}

export const UpdateMemberStoreConfig = async ({ shopId, enablePaymentIcon }) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/memberStoreConfig`,
    data: {
      enablePaymentIcon,
    },
  })
}

/**
 * 開立退款行政處理費發票 admin.memberStoreOrder.issueRefundAdminFeeInvoice
 * @param {Object} param0
 * @param {string} param0.shopId
 * @param {string} param0.id
 * @returns {Promise<Object>}
 */
export const MemberShopOrderIssueRefundAdminFeeInvoice = async ({ shopId, id }) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreOrder/${id}/issueRefundAdminFeeInvoice`,
  })
}

/**
 * 作廢退款行政處理費發票 admin.memberStoreOrder.invalidRefundAdminFeeInvoice
 * @param {Object} param0
 * @param {string} param0.shopId
 * @param {string} param0.id
 * @returns {Promise}
 */
export const MemberShopOrderInvalidRefundAdminFeeInvoice = async ({ shopId, id }) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreOrder/${id}/invalidRefundAdminFeeInvoice`,
  })
}

/**
 * 折讓退款行政處理費發票 admin.memberStoreOrder.allowanceRefundAdminFeeInvoice
 * @param {Object} param0
 * @param {string} param0.shopId
 * @param {string} param0.id
 * @returns {Promise}
 */
export const MemberShopOrderAllowanceRefundAdminFeeInvoice = async ({ shopId, id }) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreOrder/${id}/allowanceRefundAdminFeeInvoice`,
  })
}

/* 點數兌換中心 - 運送設定 */

const memberStoreDeliveryBaseUrl = (shopId) => `/${shopId}/memberStoreDelivery`
const memberStoreDeliveryConfigBaseUrl = (shopId) => `/${shopId}/memberStoreDeliveryConfig`

/**
 * 取得點數兌換中心運送方式列表 admin.memberStoreDelivery.find
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @param {number} [params.start=0] - 查詢起始
 * @param {number} [params.limit=20] - 查詢筆數
 * @param {string} [params.name] - 名稱（模糊搜尋）
 * @returns {Promise<Array>} 運送方式列表
 */
export const GetMemberStoreDelivery = async ({ shopId, start, limit, name }) => {
  return admin2({
    method: 'GET',
    url: memberStoreDeliveryBaseUrl(shopId),
    params: { start, limit, name },
  })
}

/**
 * 取得點數兌換中心運送方式數量 admin.memberStoreDelivery.find
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @param {string} [params.name] - 名稱（模糊搜尋）
 * @returns {Promise<{count: number}>}
 */
export const GetMemberStoreDeliveryCount = async ({ shopId, name }) => {
  return admin2({
    method: 'GET',
    url: `${memberStoreDeliveryBaseUrl(shopId)}/count`,
    params: { name },
  })
}

/**
 * 取得特定點數兌換中心運送方式 admin.memberStoreDelivery.find
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.id - 運送方式 ID
 * @returns {Promise<Object>}
 */
export const FindMemberStoreDelivery = async ({ shopId, id }) => {
  return admin2({
    method: 'GET',
    url: `${memberStoreDeliveryBaseUrl(shopId)}/${id}`,
  })
}

/**
 * 新增點數兌換中心運送方式 admin.memberStoreDelivery.create
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.type - 運送方式類型 ('null' | 'address' | 'ecpay')
 * @param {string} params.name - 名稱
 * @param {string} params.description - 敘述
 * @param {number} params.price - 運費原價
 * @param {boolean} params.enable - 是否啟用
 * @param {number} [params.order] - 排序
 * @param {string} [params.subType] - 超商物流類型（ECPay 時必填）
 * @param {string} [params.senderName] - 寄件人姓名（ECPay 時必填）
 * @param {string} [params.senderCellPhone] - 寄件人電話（ECPay 時必填）
 * @param {string} [params.returnStoreID] - 退貨門市代號（ECPay 時選填）
 * @param {string} [params.MemberStoreDeliveryConfigId] - 串接設定 ID（ECPay 時必填）
 * @returns {Promise<Object>}
 */
export const CreateMemberStoreDelivery = async ({
  shopId,
  type,
  name,
  description,
  price,
  enable,
  order,
  subType,
  senderName,
  senderCellPhone,
  returnStoreID,
  MemberStoreDeliveryConfigId,
}) => {
  return admin2({
    method: 'POST',
    url: memberStoreDeliveryBaseUrl(shopId),
    data: {
      type,
      name,
      description,
      price: Number(price),
      enable,
      order,
      subType,
      senderName,
      senderCellPhone,
      returnStoreID,
      MemberStoreDeliveryConfigId,
    },
  })
}

/**
 * 更新點數兌換中心運送方式 admin.memberStoreDelivery.update
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.id - 運送方式 ID
 * @param {string} [params.name] - 名稱
 * @param {string} [params.description] - 敘述
 * @param {number} [params.price] - 運費原價
 * @param {boolean} [params.enable] - 是否啟用
 * @param {boolean} [params.allowCollection] - 是否支援貨到付款
 * @returns {Promise<Object>}
 */
export const UpdateMemberStoreDelivery = async ({
  shopId,
  id,
  name,
  description,
  price,
  enable,
  order,
}) => {
  return admin2({
    method: 'PUT',
    url: `${memberStoreDeliveryBaseUrl(shopId)}/${id}`,
    data: { name, description, price, enable, order },
  })
}

/**
 * 刪除點數兌換中心運送方式
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.id - 運送方式 ID
 * @returns {Promise}
 */
export const DeleteMemberStoreDelivery = async ({ shopId, id }) => {
  return admin2({
    method: 'DELETE',
    url: `${memberStoreDeliveryBaseUrl(shopId)}/${id}`,
  })
}

/**
 * 取得點數兌換中心物流串接設定列表 admin.memberStoreDeliveryConfig.find
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @param {number} [params.start=0] - 查詢起始
 * @param {number} [params.limit=20] - 查詢筆數
 * @returns {Promise<Array>}
 */
export const GetMemberStoreDeliveryConfig = async ({ shopId, start, limit }) => {
  return admin2({
    method: 'GET',
    url: memberStoreDeliveryConfigBaseUrl(shopId),
    params: { start, limit },
  })
}

/**
 * 取得點數兌換中心物流串接設定數量 admin.memberStoreDeliveryConfig.find
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @returns {Promise<{count: number}>}
 */
export const GetMemberStoreDeliveryConfigCount = async ({ shopId }) => {
  return admin2({
    method: 'GET',
    url: `${memberStoreDeliveryConfigBaseUrl(shopId)}/count`,
  })
}

/**
 * 新增點數兌換中心物流串接設定 admin.memberStoreDeliveryConfig.create
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.type - 串接類型 ('ecpay')
 * @param {string} params.merchantID - 商店代號
 * @param {string} params.hashKey - HashKey
 * @param {string} params.hashIV - HashIV
 * @returns {Promise<Object>}
 */
export const CreateMemberStoreDeliveryConfig = async ({
  shopId,
  type,
  merchantID,
  hashKey,
  hashIV,
}) => {
  return admin2({
    method: 'POST',
    url: memberStoreDeliveryConfigBaseUrl(shopId),
    data: {
      type,
      config: {
        merchantID,
        hashKey,
        hashIV,
      },
      mode: configuration('appRuntime') === 'dev' ? 'uat' : configuration('appRuntime'),
    },
  })
}

/**
 * 刪除點數兌換中心物流串接設定
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.id - 串接設定 ID
 * @returns {Promise}
 */
export const DeleteMemberStoreDeliveryConfig = async ({ shopId, id }) => {
  return admin2({
    method: 'DELETE',
    url: `${memberStoreDeliveryConfigBaseUrl(shopId)}/${id}`,
  })
}

/**
 * 取得點數兌換中心綠界超商地圖連結（用於設定退貨門市）admin.memberStoreDeliveryConfig
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.MemberStoreDeliveryConfigId - 串接設定 ID
 * @param {string} params.subType - 超商物流類型
 * @param {string} params.clientCompleteURL - 完成後導回的 URL
 * @returns {Promise<{token: string, link: string}>}
 */
export const GetMemberStoreDeliveryCvsMap = async ({
  shopId,
  MemberStoreDeliveryConfigId,
  subType,
  clientCompleteURL,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/memberStoreDeliveryEcpayMap`,
    data: {
      memberStoreDeliveryConfigId: MemberStoreDeliveryConfigId,
      clientCompleteURL,
      subType,
      device: 0,
    },
  })
}

/**
 * 查詢點數兌換中心綠界超商地圖選取結果
 * @param {Object} params
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.token - 地圖選取 token
 * @returns {Promise<{CVSStoreID: string, CVSStoreName: string, CVSAddress: string}>}
 */
export const GetMemberStoreDeliverySelectedCvs = async ({ shopId, token }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/memberStoreDeliveryEcpayMap`,
    params: { token },
  })
}

/**
 * 香水機台結帳頁面設定 - 取得設定
 * @param {string} shopId - 門市 ID
 * @returns {Promise} API 回應
 */
export function GetTricentVendingConfig (shopId) {
  return admin2({
    method: 'GET',
    url: `/${shopId}/amgVendingScanConfig`,
  })
}

/**
 * 香水機台結帳頁面設定 - 更新設定
 * @param {string} shopId - 門市 ID
 * @param {object} data - 設定資料
 * @param {boolean} [data.enableGuestCheckout] - 是否啟用訪客結帳
 * @param {string} [data.iconImageId] - 圖示圖片 ID
 * @param {string} [data.backgroundImageId] - 背景圖片 ID
 * @param {string} [data.content] - 簡述內容
 * @param {string} [data.checkoutBackgroundImageId] - 結帳頁背景圖片 ID
 * @param {string} [data.checkoutContext] - 結帳頁簡述內容
 * @returns {Promise} API 回應
 */
export function UpdateTricentVendingConfig (shopId, data) {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/amgVendingScanConfig`,
    data,
  })
}
